import React from 'react';
import clsx from 'clsx';
import Button from 'components/UI/V3/Button/Button';
import styles from './IntegrationCard.module.scss';

export interface IntegrationCardProps {
    icon: string;
    title: string;
    description: string;
    onViewClick?: () => void;
    // 'wide' fits rectangular logos (e.g. iDogCam) instead of cropping them into a circle.
    iconShape?: 'round' | 'wide';
    className?: string;
}

export const IntegrationCard: React.FC<IntegrationCardProps> = ({
    icon,
    title,
    description,
    onViewClick,
    iconShape = 'round',
    className
}) => {
    return (
        <div className={clsx(styles.root, className)}>
            <div className={clsx(styles.iconWrapper, iconShape === 'wide' && styles.iconWrapperWide)}>
                <img
                    src={icon}
                    alt={`${title} logo`}
                    className={styles.icon}
                />
            </div>
            <div className={styles.content}>
                <div className={styles.textContent}>
                    <h3 className={styles.title}>{title}</h3>
                    <p className={styles.description}>{description}</p>
                </div>
            </div>
            <div className={styles.actionWrapper}>
                <Button
                    label="View"
                    variant="black"
                    size="medium"
                    onClick={onViewClick}
                />
            </div>
        </div>
    );
};

export default IntegrationCard;
